import { render, staticRenderFns } from "./QLGeneraleServizi.vue?vue&type=template&id=6c1dea89&"
import script from "./QLGeneraleServizi.vue?vue&type=script&lang=js&"
export * from "./QLGeneraleServizi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports